import { gql } from "@apollo/client";
import { ButtonBase, Paper } from "@mui/material";
import VideoThumbnail from "atoms/VideoThumbnail";
import EventMarker, { EventMarkerFragment } from "molecules/EventMarker";
import ViewCountLabel from "molecules/ViewCountLabel";
import HighlightPlayerDialog from "pages/video_player/HighlightPlayerDialog";
import React, { useState } from "react";

export const EventCardFragment = gql`
  fragment EventCardFragment on Event {
    id
    thumbnailUrl
    videoUrl
    videoPending
    viewCount
    ...EventMarkerFragment
  }
  ${EventMarkerFragment}
`;

export default function EventCard({ event }) {
  const [dialogOpen, dialogOpenSet] = useState(false);
  return (
    <>
      <HighlightPlayerDialog eventId={event.id} open={dialogOpen} onClose={() => dialogOpenSet(false)} />
      <ButtonBase
        component={ButtonBase}
        href={`/event/${event.id}`}
        onClick={(event) => {
          if (event.ctrlKey || event.shiftKey || event.metaKey || event.altKey) return;
          event.preventDefault();
          dialogOpenSet(true);
        }}
        style={{
          display: "flex",
          justifyContent: "stretch",
          alignItems: "stretch",
        }}
      >
        <VideoThumbnail
          component={Paper}
          previewable
          thumbnailUrl={event.thumbnailUrl}
          videoUrl={event.videoUrl}
          processing={event.videoPending}
          style={{ width: "100%" }}
          leftLabel={<EventMarker size={18} event={event} />}
          rightLabel={<ViewCountLabel viewCount={event.viewCount} />}
        />
      </ButtonBase>
    </>
  );
}
